<!doctype html>
<html lang="da">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="icon" href="favicon.ico" type="image/x-icon" />
        <link rel="shortcut icon" href="favicon.ico" type="image/x-icon" />
        <link rel="icon" href="favicon.ico?v=2024041501" type="image/x-icon" />
        <title>Mit Evida - Under Vedligeholdelse</title>
        <style>
            body {
                display: flex;
                flex-direction: column;
                min-height: 100vh;
                font-family: 'Fibra One Alt', Arial, sans-serif;
                margin: 0;
                padding: 0;
                color: #333;
                background-color: #fff;
            }
            .header {
                padding: 15px 0;
                background-color: white;
                border-bottom: 1px solid #eee;
            }
            .header-content {
                width: 100%;
                margin: 0;
                display: flex;
                align-items: center;
            }
            .header img {
                height: 40px;
            }
            .content {
                flex: 1;
                max-width: 700px;
                margin: 0 auto;
                padding: 20px 40px;
            }
            .alert-title {
                font-size: 2.5em;
                color: #0e4744;
                margin: 40px 0 20px 0;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
            }
            .alert-title img {
                width: 3rem;
                height: 3rem;
                margin-right: 15px;
            }
            .maintenance-image {
                width: 100%;
                height: auto;
                margin: 20px 0 10px 0;
                border-radius: 4px;
                object-fit: cover;
            }
            .notice-box {
                background-color: #fdf6e3;
                padding: 25px;
                border-radius: 4px;
                margin: 10px 0 30px 0;
            }
            .notice-title {
                font-weight: bold;
                margin-bottom: 10px;
                color: #0e4744;
            }
            .notice-content {
                color: #0e4744;
                line-height: 1.5;
            }
            .read-more {
                color: #2c6943;
                text-decoration: underline;
                display: inline-block;
                margin-left: 5px;
                font-weight: bold;
            }
            footer {
                background-color: #0e4744;
                color: white;
                padding: 40px 20px;
                width: 100%;
                font-size: 14px;
            }

            .footer-content {
                display: flex;
                justify-content: space-between;
                width: 100%;
                max-width: 1200px;
                margin: 0 auto;
            }

            .company-info {
                text-align: left;
                margin-top: 10px;
                line-height: 1.4;
            }

            .footer-logo {
                width: 80px;
                margin-bottom: 10px;
            }

            .links {
                text-align: right;
                margin-top: 10px;
            }

            .links a {
                display: block;
                color: white;
                text-decoration: none;
                margin-bottom: 6px;
                line-height: 1.2;
            }
            @media (max-width: 768px) {
                .footer-content {
                    flex-direction: column;
                }
                .links {
                    margin-top: 30px;
                    text-align: left;
                }
                .content {
                    padding: 20px;
                }
            }
            @media (max-width: 480px) {
                .alert-title {
                    font-size: 2em;
                    flex-direction: column;
                    text-align: center;
                }
                .alert-title img {
                    margin-right: 0;
                    margin-bottom: 10px;
                }
            }
        </style>
    </head>
    <body>
        <div class="header">
            <div class="header-content">
                <img src="../../../../assets/image/MitEvidaLogo.svg" alt="Evida Logo" />
            </div>
        </div>
        <div class="content">
            <div class="alert-title">
                <img src="../../../../assets/image/warning.svg" alt="Advarsel" />
                Vi bygger om på Mit Evida
            </div>
            <img class="maintenance-image" src="../../../../assets/image/build.svg" alt="Under konstruktion" />
            <div class="notice-box">
                <div class="notice-title">OBS:</div>
                <div class="notice-content">
                    Fra <strong>onsdag den 23. april kl. 16.00 til tirsdag den 29. april</strong> vil der være lukket
                    for adgang, mens vi arbejder. Beklager ulejligheden.
                    <a
                        href="https://www.evida.dk/undskyld-vi-roder/"
                        class="read-more"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Læs mere</a
                    >
                </div>
            </div>
        </div>
        <footer>
            <div class="footer-content">
                <div>
                    <img class="footer-logo" src="../../../../assets/image/MitEvidaLogo.svg" alt="Evida Logo" />
                    <div class="company-info">
                        Evida<br />
                        Vognmagervej 14<br />
                        8800 Viborg
                    </div>
                </div>
                <div class="links">
                    <a href="https://evida.dk/privatlivspolitik/" target="_blank" rel="noopener noreferrer"
                        >Privatlivspolitik</a
                    >
                    <a href="https://evida.dk/vejledninger/reklamationer/" target="_blank" rel="noopener noreferrer"
                        >Reklamationer</a
                    >
                    <a href="https://evida.dk/driftsinfo/" target="_blank" rel="noopener noreferrer">Driftsinfo</a>
                    <a href="https://miw.gasnet.dk/login/" target="_blank" rel="noopener noreferrer"
                        >Indberet produktionstal</a
                    >
                </div>
            </div>
        </footer>
    </body>
</html>
